import { UserPlus, X } from 'lucide-react';
import { ownerBreakdownText, plural, BULK_REASSIGN_MAX, type PickedLead } from './bulkReassign';

/** "N leads selected · Reassign to… · Clear · Owner: X (n) · Y (m)" */
export function BulkReassignBar({ leads, onReassign, onClear }: {
  leads: PickedLead[];
  onReassign: () => void;
  onClear: () => void;
}) {
  const tooMany = leads.length > BULK_REASSIGN_MAX;
  return (
    <div
      data-tour="leads-bulk-bar"
      role="region"
      aria-label="Selected leads"
      className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-indigo-500/30 bg-indigo-500/10 px-3 py-2 text-sm"
    >
      <span className="font-semibold text-[var(--text-primary)]">{plural(leads.length, 'lead')} selected</span>
      <button
        type="button"
        onClick={onReassign}
        disabled={tooMany}
        className="flex items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-indigo-700 disabled:opacity-50"
      >
        <UserPlus size={14} /> Reassign to…
      </button>
      <button
        type="button"
        onClick={onClear}
        className="flex items-center gap-1 rounded-lg border border-[var(--border-primary)] px-3 py-1.5 text-xs font-medium text-[var(--text-secondary)] hover:bg-[var(--bg-inset)]"
      >
        <X size={13} /> Clear
      </button>
      <span className="min-w-0 basis-full text-xs text-[var(--text-muted)] sm:basis-auto">Owner: {ownerBreakdownText(leads)}</span>
      {tooMany && <span className="basis-full text-xs text-red-400">At most {BULK_REASSIGN_MAX} at a time.</span>}
    </div>
  );
}
